module.exports = __webpack_public_path__ + "img/digi-crush-5.8990fd34.png";